import { push } from 'connected-react-router';

export default (reportId, creditId) => (dispatch) => {
    if (reportId) dispatch(push(`/report/${reportId}`));
    else {
        dispatch(push(`/credits/file/${creditId || ''}`));
    }
};
